/* eslint-disable */
// @ts-nocheck

import React from "react";
import {
  displacementFnc,
  pressureFnc,
  pressureMinMaxFnc,
  velocityFnc,
} from "../../components/common/ant-novak/waveguide/helpers/WaveGuide.mainEquations";
import { SIGNAL_CHOICE } from "../../components/common/ant-novak/waveguide/helpers/WaveGuide.signals";
import WaveGuide from "../../components/common/ant-novak/waveguide/WaveGuide";
import { COLORS } from "../../helpers/ant-novak/helpers";
import v from "../../components/common/ant-novak/waveguide/latex_svg/v.svg";
import v_units from "../../components/common/ant-novak/waveguide/latex_svg/v_units.svg";

// import React from "react";
// import WaveGuide from "./WaveGuide.jsx";
// import { SIGNAL_CHOICE } from "./helpers/WaveGuide.signals.js";
// import { COLORS } from "../../helpers/helpers.js";
// import v from "./latex_svg/v.svg";
// import v_units from "./latex_svg/v_units.svg";
// import {
//   pressureFnc,
//   velocityFnc,
//   displacementFnc,
//   pressureMinMaxFnc,
// } from "./helpers/WaveGuide.mainEquations.js";

const props = {
  colormap: { name: "RdBu", unit: "Pa" },
  microphone: { show: true, x: 0.5 },
  signals: [
    {
      title: "Harmonic",
      type: SIGNAL_CHOICE.HARMONIC,
      freq: { value: 550, can_be_modified: true, minmax: [0, 1000] },
      A: { abs: 0.0, arg: 0.0, edit: false, arg_edit: false, inv_edit: false },
      B: { abs: 1.0, arg: 0.0, edit: false, arg_edit: false, inv_edit: false },
      graph_limits: { pmax: 2, vmax: 0.006, auto: false },
      standing_waves: false,
      drawMinMax: pressureMinMaxFnc,
    },
  ],
  physics: {
    pressureFnc: pressureFnc,
    velocityFnc: velocityFnc,
    displacementFnc: displacementFnc,
    drawFnc: pressureFnc,
    vectorFnc: velocityFnc,
    radius: { values: [1.0 / 8, 1.0 / 8] },
    rho: [1.2, 1.2],
    c0: [340, 340],
    medium: { edit: false, title: "medium: air" },
    loss_factor: 1e2 * 3e-6,
    reflection: { edit: false, x: 0.0, flip: true },
    openclosed: true,
    impedanceFreq: true,
  },
  graphs: { impedance_freq: true },
  pressure_colors: { can_be_modified: true, show: true },
  velocity_arrows: { can_be_modified: true, show: false, size_ratio: 6000, color: COLORS[1] },
  text: [
    {
      left: "70%",
      variable: { img: v },
      units: { img: v_units },
      fnc: fnc_dp_dx,
    },
  ],
};

function fnc_dp_dx(properties, t) {
  const { physics, signal } = properties;
  const v = velocityFnc(signal, 1.0, 1.0, t, physics, 0);
  return v * 1000;
}

export function WaveGuideLesson08() {
  return (
    <div className={"app"}>
      <div className={"my-div"}>
        <WaveGuide {...props} />
      </div>
    </div>
  );
}
